import './exceptions.styles.scss';
import { useContext, useState, useEffect } from 'react';
import { SimContext } from '../../../api/SimContext';
import HeadingSecondary from '../../../components/typography/headings/heading-secondary/heading-secondary.component';
import { IoMdSearch } from 'react-icons/io';
import { IoReloadCircleSharp } from 'react-icons/io5';
import { MdArrowBack } from 'react-icons/md';
import { MdArrowForward } from 'react-icons/md';
const ExceptionScreen = ( {setExceptionCount}) => {
    const { allSims, offers, sellSim, reloadKey, setReloadKey, simToInv, pageCount, setPageCount } = useContext(SimContext);
    const [isSpinning, setIsSpinning] = useState(false);
    const handleReload = () => {
      setIsSpinning(true);
      setTimeout(() => {
        setReloadKey(reloadKey + 1);
        setIsSpinning(false);
      }, 1200); // Match this duration with the CSS animation duration
    };
    const [searchTerm, setSearchTerm] = useState('');
    const productOptions = offers.map(offer => ({
      'name': offer.name,
      'id': offer.id
    }));
    // const productOptions = offers.map(offer => ({ label: offer.name, value: offer.id })); // NIEUW
    const durationOptions = [
      { name: "1 day", dayNumber: 1 },
      { name: "3 days", dayNumber: 3 },
      { name: "7 days", dayNumber: 7 }
  ];
    const [selections, setSelections] = useState({});
    const [filteredExceptionSims, setFilteredExceptionSims] = useState([]);
    function formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    // Search and filtering logic
    useEffect(() => {
      const filtered = allSims.filter(sim => {
        const matchesSearchTerm = (sim.msisdn && sim.msisdn.toString().toLowerCase().includes(searchTerm.toLowerCase())) || 
                                  (sim.eid && sim.eid.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                                  (sim.offer && sim.offer.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                                  (sim.tags && sim.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase())));
    
        return (sim.status === "ACTIVE" &&
                sim.tags && !sim.tags.some(tag => tag.includes("Sold")) &&
                matchesSearchTerm) || 
               (sim.status === "INACTIVE" &&
                sim.tags && sim.tags.some(tag => tag.includes("Sold")) &&
                matchesSearchTerm);
      });
    
      setFilteredExceptionSims(filtered);
    }, [allSims, searchTerm]);
    
    useEffect(() => {
        setExceptionCount(filteredExceptionSims.length)
      }, [filteredExceptionSims.length]);

  // Page flipper logic
  const handleBackClick = () => {
    if (pageCount > 0) {
        setPageCount(prevCount => prevCount - 1); 
    }
  };
  
  const handleForwardClick = () => {
      setPageCount(prevCount => prevCount + 1); 
  };

    return (
      <div className='content-container-component'>
          <div className="messages-container">
          <div className='table-heading-container'>
              <IoReloadCircleSharp size={28} color='black' onClick={handleReload} style={{ cursor: 'pointer'}} className={`reload-div ${isSpinning ? 'spin-animation' : ''}`} />
              {/* <div className='page-flip-container'>
                <MdArrowBack size={26} color='black' onClick={handleBackClick} />
                <div className='page-flipper-text'>{pageCount + 1}</div>
                <MdArrowForward size={26} color='black' onClick={handleForwardClick} />
              </div> */}
              <div className="search-container">
              <IoMdSearch size={28} color= '#646272'/>
                <input 
                    type="text" 
                    className="search-input" 
                    placeholder="Search SIM"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            </div>
            <div className='table-scroll-container'>
              <div className='panel-small'>
                <div className='panel-heading'> 
                  <div className='inner-panel-heading'>
                    <div className='header-container-reseller'>
                      <HeadingSecondary text={`MSISDN - SIM EID`} mode={'light'}/>
                    </div>
                    <div className='header-container-reseller'>
                      <HeadingSecondary text={`Product`} mode={'light'}/>
                    </div>
                    <div className='header-container-reseller'>
                      <HeadingSecondary text={`Activation Date`} mode={'light'}/>
                    </div>
                    <div className='header-container-reseller'>
                      <HeadingSecondary text={`Action`} mode={'light'}/>
                    </div>
                  </div>
                </div>
                    <div className='panel-content-container'>
                        <div className='sim-heading-container'>
                            <div className='sortby-container'>
                            </div>
                        </div>
                        <div className='scroll-container'>
                            {filteredExceptionSims.map(sim => (
                                <div key={sim.eid} className="reseller-block-table">
                                    <div className="sim-info-reseller">
                                      <div className="sim-text-bold">{sim.msisdn}<br/>{sim.eid}
                                        </div>
                                    </div>
                                    <div className='dropdown-container'>
                                      <div className='sim-text-bold'>
                                        {sim.offer}
                                      </div>
                                    </div>
                                    <div className='dropdown-container'>
                                      <div className='sim-text'>
                                        {formatDate(sim.activatedDate)}
                                        </div>
                                    </div>
                                    <div className='sell-button-container' onClick={() => {
                                            if (!selections[sim.id]?.sold) {
                                                simToInv(sim.id);
                                                setSelections(prev => ({
                                                  ...prev,
                                                  [sim.id]: {
                                                      ...prev[sim.id],
                                                      inv: true  
                                                  }
                                              }));
                                              setTimeout(() => {
                                                setFilteredExceptionSims(currentSims => currentSims.filter(s => s.id !== sim.id));
                                            }, 800); 
                                            } else {
                                                console.log("SIM is already out of inventory."); 
                                            }
                                        }}>
                                        <div className={`${selections[sim.id]?.inv ? 'loader' : 'sell-block'}`}> 
                                            <div className='sim-text'>{selections[sim.id]?.inv ? '' : 'Set Inventory'}</div>
                                        </div>
                                    </div>
                                </div>
                                
                            ))}
                        </div>
                        
                    </div>
              </div>
          </div>
          </div>
      </div>
  );
};

export default ExceptionScreen;